let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("6hlj7")]).then(() => parcelRequire('3huTA'));